import { render, staticRenderFns } from "./MobileNavFooter.vue?vue&type=template&id=0b3bd5b1&"
import script from "./MobileNavFooter.vue?vue&type=script&lang=js&"
export * from "./MobileNavFooter.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MobileNavFooter.vue"
export default component.exports